// extracted by mini-css-extract-plugin
module.exports = {"input":"_3PTDe","label":"_1CeYz","selected":"_2s27H"};